import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Children } from 'react';
import getElementName from './getElementName.js'; // eslint-disable-next-line max-lines-per-function

var groupByType = function groupByType(children) {
  var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var rest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rest';
  var typeNames = types.map(function (type) {
    return typeof type === 'string' ? type : type.name;
  });
  return Children.toArray(children).reduce(function (acc, child) {
    var elementName = getElementName(child);
    var key = elementName !== null && typeNames.includes(elementName) ? elementName : rest;

    if (typeof acc[key] === 'undefined') {
      acc[key] = [];
    }

    acc[key] = [].concat(_toConsumableArray(acc[key]), [child]);
    return acc;
  }, {});
};

export default groupByType;